import { defineMessages } from "react-intl";

const idPrefix = "error.";

export const fatalErrorMessages = defineMessages({
    defaultTitleLabel: {
        defaultMessage: "An unexpected error has occurred.",
        id: idPrefix + "defaultTitle-label",
    },
    defaultInstructionsLabel: {
        defaultMessage: "Please refresh the page. If the issue persists please contact the site owner with the tracking issue information below.",
        id: idPrefix + "defaultInstructions-label",
    },
    defaultErrorIdentifierLabel: {
        defaultMessage: "Tracking Issue:",
        id: idPrefix + "defaultErrorIdentifier-label",
    },
    generatedErrorIdentifierLabel: {
        defaultMessage: "Generated Tracking Issue",
        id: idPrefix + "generatedErrorIdentifier-label",
    },
});
